import { useEffect, useState } from 'react'

import { authService } from '@ui/services'

export const useHasStack = () => {
  const [loading, setIsLoading] = useState(true)
  const [hasStack, setHasStack] = useState(false)

  useEffect(() => {
    const checkIfHasStack = async () => {
      setIsLoading(true)

      const validSession = await authService.validateSession()

      setHasStack(Boolean(validSession.has_stack))

      console.log('hasStack', Boolean(validSession.has_stack))

      setIsLoading(false)
    }

    checkIfHasStack()
  }, [])

  return { loading, hasStack }
}
